var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$route.meta.private)?[_c('AdminDesign',[_c('router-view')],1)]:[_c('router-view')],_c('ClosableAlerts',{ref:"closableAlerts"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }